import React from 'react';

// Upload button for the file upload component
const UploadButton = ({ onClick, uploading }) => (
  <button 
    onClick={onClick} 
    disabled={uploading}
    className={`py-2 px-4 rounded-lg font-semibold transition-colors 
      ${uploading ? 'bg-gray-500 text-white cursor-not-allowed' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
  >
    {uploading ? 'Uploading...' : 'Upload Files'}
  </button>
);

export default UploadButton;
